// import { API_HOST } from '../../config/_entrypoint';

export function postLogin (values, history) {
  return (dispatch) => {
    dispatch(postLoginRequest());
    let url = `${process.env.REACT_APP_API_HOST}/login_check`;
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    return fetch(url, {method: 'POST', body: JSON.stringify(values), headers: headers })
      .then(response => response.json())

      .then(response => {
        if (response.token) {
          // console.log(response.token);
          localStorage.setItem('betwidgets_login_token', response.token);
          dispatch(postLoginSuccess(response));
          history.push('/dashboard');
          return response;
        }
        else {
          throw(response);
        }
      })
      .catch(e => {
        dispatch(postLoginError(e.message));
      });
  };
}

const postLoginRequest = () => {
  return {
    type: 'POST_LOGIN_REQUEST',
  }
}
const postLoginSuccess = (response) => {
  return {
    type: 'POST_LOGIN_SUCCESS',
    response
  }
}
export const postLoginError = (error) => {
  return {
    type: 'POST_LOGIN_ERROR',
    error
  }
}




// WEBPACK FOOTER //
// ./src/actions/auth/login.js